/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import Modal from 'react-modal';
import { Button, Grid, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector, useDispatch } from 'react-redux';
import CustomUploadField from '../shared/CustomUploadField';
import { DIMENSIONS } from '../../constants/aspectRatio';
import 'react-toastify/dist/ReactToastify.css';
import { showProgress, getInstructorList } from '../../redux/actions/DealershipActions';
import Theme from '../ui/Theme';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { ErrorToast, MultipleErrorToast, notifySuccess } from '../utils/Utils';

const FormData = require('form-data');
const useStyles = makeStyles(() => ({
  addBtn: {
    width: '222px',
    height: '48px',
    marginLeft: '16px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },

  cancelBtn: {
    width: '222px',
    height: '48px',
    marginLeft: '12px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
  },
  popupLabels: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    textAlign: 'left',
    marginTop: '9px',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  resize: {
    backgroundColor: '#fff',
    height: '45px',
    width: '440px',
    padding: '5px 10px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '17px',
    lineHeight: '21px',
    marginTop: '9px',
    borderRadius: '8px',
    border: '1px solid #E0E0E0',
  },
}));

const AddSource = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [viewSourcePop, setViewSourcePop] = useState(true);
  const [thumbnail, setThumbnail] = useState('');
  const [thumbnailImg, setThumbnailImg] = useState(null);
  const [thumbnailFileName, setThumbnailFileName] = useState('');
  const [sourceTitle, setSourceTitle] = useState('');
  const [imageData, setImageData] = useState();
  const instrList = useSelector((state) => state.getInstructorList.instrList);

  React.useEffect(() => {
    instrList?.forEach((data) => {
      if (data.id === props.selId) {
        setSourceTitle(data.name);
        setThumbnail(data.thumbnail);
      }
    });
  }, []);
  const handleImageChangeNew = (e) => {
    const file = e.target.files[0];
    setImageData(file);
    setThumbnailFileName(file?.name);
    const reader = new FileReader();
    reader.onload = (ev) => {
      setThumbnailImg(ev.target.result);
    };
    reader.readAsDataURL(file);
  };

  const handleDeleteThumbnail = () => {
    setImageData(undefined);
    setThumbnail('');
    setThumbnailImg(null);
    setThumbnailFileName('');
  };
  const validateForm = () => {
    const errors = [];
    let formIsValid = true;
    if (!sourceTitle) {
      formIsValid = false;
      errors.push('Please enter source title.');
    }
    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return formIsValid;
  };

  const submit = async () => {
    const check = validateForm();
    const datas = new FormData();
    if (check) {
      dispatch(showProgress(true));
      datas.append('name', sourceTitle);
      datas.append('type', props.doseType);
      if (typeof imageData !== 'string') {
        if (imageData !== undefined) {
          datas.append('thumbnail', imageData);
        }
      }
      if (props.edit === false) {
        await service
          .post(apiEndpoints.STORY_SOURCES, datas)
          .then((response) => {
            dispatch(getInstructorList('append', response));
            notifySuccess('Completed Successfully');
            props.onSuccess?.(response);
            closePopup();
            dispatch(showProgress(false));
          })
          .catch((error) => {
            ErrorToast(error);
            dispatch(showProgress(false));
          });
      } else {
        await service
          .put(apiEndpoints.STORY_SOURCES_UPDATE.replace('ID', props.selId), datas)
          .then((response) => {
            dispatch(getInstructorList('update', response));
            notifySuccess('Completed Successfully');
            props.onSuccess?.(response);
            closePopup();
            dispatch(showProgress(false));
          })
          .catch((error) => {
            ErrorToast(error);
            dispatch(showProgress(false));
          });
      }
    }
  };
  const handleSourceTitleChange = (e) => {
    setSourceTitle(e.target.value);
  };

  const closePopup = () => {
    setViewSourcePop(false);
    props.close();
  };

  return (
    <Modal
      isOpen={viewSourcePop}
      onRequestClose={() => false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'hsla(50, 33%, 25%, 0.35)',
        },
        content: {
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          border: 0,
          height: '326px',
          width: '500px',
          overflow: 'auto',
        },
      }}
    >
      <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
        <Grid item>
          <Grid container direction="column" justifyContent="space-between" alignItems="flex-start">
            <Grid item className={classes.popupHeading}>
              {props.edit === false ? 'Add Instructor' : 'Edit Instructor'}
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <CloseIcon className={classes.popupCloseBtn} onClick={closePopup} />
        </Grid>
      </Grid>
      <Grid
        container
        direction="column"
        style={{ marginTop: '24px' }}
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <div className={classes.popupLabels}>
          <label htmlFor="courseOverview">Enter Name</label>
        </div>
        <Grid item>
          <TextField
            id="sourceTitleId"
            name="sourceTitle"
            required
            autoFocus
            autoComplete="off"
            autoSave="off"
            onChange={handleSourceTitleChange}
            placeholder="Enter name here"
            multiline
            InputProps={{
              disableUnderline: true,
              classes: {
                input: classes.resize,
              },
            }}
            value={sourceTitle}
            rows={1}
          />
        </Grid>
        <Grid item>
          <Grid item>
            <p className={classes.popupLabels}>Profile Image(Max-size 25KB)</p>
          </Grid>
          <CustomUploadField
            type="image"
            name="instructor-profile-image"
            value={thumbnailImg}
            imgSrc={!imageData ? thumbnail : null}
            handleChange={handleImageChangeNew}
            customStyles={{ width: '460px' }}
            fileName={thumbnailFileName}
            dimensions={DIMENSIONS.instructor}
            handleDelete={handleDeleteThumbnail}
          />
        </Grid>

        <Grid item>
          <Grid container direction="row" style={{ marginTop: '24px' }}>
            <Grid item>
              <Button onClick={closePopup} variant="contained" disableElevation className={classes.cancelBtn}>
                Cancel
              </Button>
              <Button variant="contained" color="primary" className={classes.addBtn} onClick={() => submit()}>
                Save
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default AddSource;
